<template>
  <div class="radio-checkbox-group">
    <m4-label v-if="labelAbove" :for="$attrs.id" :error="!!error" class="radio-checkbox-group__label-above">
      {{ labelAbove }}
    </m4-label>
    <div class="radio-checkbox-group__radio-wrapper" v-for="(option, index) in options" :key="index">
      <m4-radio
        :native-value="option.value"
        v-model="parentValue"
        class="radio-checkbox-group__radio-wrapper__radio"
        :name="name"
      >
        <span v-html="option.label"></span>
      </m4-radio>
    </div>
    <div v-if="children && children.length > 0" class="radio-checkbox-group__children">
      <div v-for="(option, index) in children" :key="index" class="radio-checkbox-group__children_child">
        <m4-checkbox
          :name="option.name"
          :native-value="option.value"
          true-value="Yes"
          false-value="No"
          @update:modelValue="(val) => checkboxChange(option.value, val)"
          :modelValue="isChecked(option.value)"
        >
          <span v-html="option.label"></span>
        </m4-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4RadioCheckboxGroup",
  data() {
    let defaultValue = this.modelValue && this.modelValue.length > 0 ? this.modelValue : this.value ? this.value : [];

    return {
      newValue: defaultValue
    };
  },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    modelValue: {
      type: Array,
      default() {
        return [];
      }
    },
    name: String,
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    labelAbove: String
  },
  emit: ["update:modelValue"],
  computed: {
    parentValue: {
      get() {
        return this.newValue[0] !== undefined ? this.newValue[0] : null;
      },
      set(value) {
        let newValue = [];
        newValue[0] = value;

        this.newValue = newValue;
        this.$emit("update:modelValue", this.newValue);
      }
    },
    children() {
      let currParent = this.options.find((item) => {
        if (item.value === this.parentValue) {
          return item;
        }
      });

      if (currParent) {
        return currParent.children;
      }

      return [];
    }
  },
  methods: {
    isChecked(val) {
      if (this.newValue.indexOf(val) !== -1) {
        return "Yes";
      }
      return null;
    },
    checkboxChange(optionVal, val) {
      if (val === "Yes") {
        if (this.newValue.indexOf(optionVal) === -1) {
          this.newValue.push(optionVal);
        }
      } else {
        const valIndex = this.newValue.indexOf(optionVal);
        if (valIndex !== -1) {
          this.newValue.splice(valIndex, 1);
        }
      }
    }
  }
};
</script>
